import dynamic from 'next/dynamic'

export const DynamicVideoBannerModal = dynamic(
  () => import('.').then((mod) => mod.VideoBannerModal),
  { ssr: false },
)
